import type { TVConfig } from '@nuxt/ui';
import type * as ui from '#build/ui';

export default {
    slots: {
        root: 'auth-form',
    },
} satisfies TVConfig<typeof ui>['authForm'];
